// extracted by mini-css-extract-plugin
export default {"classifyEnable":"enableAction-module--classify-enable--iAjBd"};